import { Box, Chip, TextField, CircularProgress, Typography } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import React, { useEffect, useState } from "react";
import toastError from "../../errors/toastError";
import api from "../../services/api";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  filterBox: {
    width: "100%",
    "& .MuiAutocomplete-root": {
      padding: 0,
    },
    "& .MuiOutlinedInput-root": {
      padding: "6px 12px",
      height: 40,
      fontSize: "13px",
      borderRadius: 8,
      backgroundColor: theme.palette.mode === "light" ? "rgba(0,0,0,0.02)" : "rgba(255,255,255,0.02)",
      border: `1px solid ${theme.palette.divider}`,
      transition: "all 0.2s ease",
      "&:hover": {
        borderColor: theme.palette.primary.main,
        backgroundColor: theme.palette.mode === "light" ? "rgba(0,0,0,0.04)" : "rgba(255,255,255,0.04)",
      },
      "&.Mui-focused": {
        borderColor: theme.palette.primary.main,
        boxShadow: `0 0 0 3px ${theme.palette.primary.main}20`,
      },
    },
    "& .MuiAutocomplete-tag": {
      margin: "2px 4px",
      height: 26,
      fontSize: "12px",
    },
  },
}));

export function TagsFilter({ onFiltered }) {
  const classes = useStyles();
  const [tags, setTags] = useState([]);
  const [selecteds, setSelecteds] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    async function fetchData() {
      await loadTags();
    }
    fetchData();
  }, []);

  const loadTags = async () => {
    try {
      setLoading(true);
      const { data } = await api.get(`/tags/list`, {
        params: { kanban: 0 }
      });
      setTags(data);
      setLoading(false);
    } catch (err) {
      console.error('TagsFilter - Erro ao carregar tags:', err);
      toastError(err);
      setLoading(false);
    }
  };

  const onChange = async (value) => {
    setSelecteds(value);
    onFiltered(value);
  };

  return (
    <Box className={classes.filterBox}>
      <Autocomplete
        multiple
        size="small"
        options={tags}
        value={selecteds}
        loading={loading}
        onChange={(e, v, r) => onChange(v)}
        getOptionLabel={(option) => option.name || ''}
        getOptionSelected={(option, value) => option.id === value.id}
        filterOptions={(options, state) => {
          const inputValue = state.inputValue.toLowerCase().trim();
          if (!inputValue) return options;
          return options.filter(option => 
            option.name.toLowerCase().includes(inputValue)
          );
        }}
        renderOption={(option) => (
          <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            padding: '8px 12px',
            width: '100%',
            cursor: 'pointer'
          }}>
            <Chip
              size="small"
              label={option.name}
              style={{
                backgroundColor: option.color || '#2196f3',
                color: '#FFF',
                fontWeight: 'bold',
                fontSize: '0.85em',
                boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
              }}
            />
          </div>
        )}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip
              variant="outlined"
              style={{
                backgroundColor: option.color || "#2196f3",
                textShadow: "1px 1px 1px #000",
                color: "white",
                fontWeight: 'bold',
                border: 'none',
                height: 28,
                fontSize: '12px',
              }}
              label={option.name}
              {...getTagProps({ index })}
              size="small"
            />
          ))
        }
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            placeholder="🏷️ Tags"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loading ? <CircularProgress color="inherit" size={16} /> : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
        PaperComponent={({ children }) => (
          <Box
            style={{ 
              maxHeight: 300,
              overflow: 'auto',
              border: `1px solid #1976d2`,
              borderRadius: 8,
              marginTop: 4,
              boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
              backgroundColor: '#ffffff'
            }}
          >
            {children}
          </Box>
        )}
        noOptionsText={
          <Typography variant="body2" style={{ padding: 12, textAlign: 'center', color: '#666', fontSize: '12px' }}>
            {loading ? "Carregando..." : "Nenhuma tag encontrada"}
          </Typography>
        }
        loadingText="Carregando tags..."
        openOnFocus
        autoHighlight
        disableCloseOnSelect
      />
    </Box>
  );
}
